/* eslint import/no-cycle: 0 */
import React from 'react'
import Icon from '../../../icon'
import { If } from '../../../if/if'
import { NavItemProps } from './props'

import {
  Container,
  IconWrapper,
  Item,
  ItemName,
  Submenu,
  ToggleButton,
} from './styles'

const NavItem = ({
  item,
  sidebarIsOpen,
  currentSubmenuIndex,
  index,
  handleItem,
}: NavItemProps) => (
  <Container
    key={item.name}
    itemAmount={item.subitems.length}
    isOpen={sidebarIsOpen && currentSubmenuIndex === index}
  >
    <Item onClick={() => handleItem(item, index)}>
      <IconWrapper>
        <Icon name={item.icon} />
      </IconWrapper>
      <ItemName isOpen={sidebarIsOpen}>{item.name}</ItemName>
      <If condition={item.subitems.length > 0 && sidebarIsOpen}>
        <ToggleButton>
          <Icon name={currentSubmenuIndex === index ? 'arrow-down' : 'arrow-right'} />
        </ToggleButton>
      </If>
    </Item>

    <Submenu>
      {
        currentSubmenuIndex === index && item.subitems.map((subitem) => (
          <Item key={subitem.name} onClick={() => handleItem(subitem, index)}>
            <ItemName isOpen>{subitem.name}</ItemName>
          </Item>
        ))
      }
    </Submenu>
  </Container>
)

export default React.memo(NavItem)
